export enum MatchStateTypeEnum {
  FirstHalf = "FIRST_HALF",
  SecondHalf = "SECOND_HALF",
  ExtraTimeFirstHalf = "EXTRA_TIME_FIRST_HALF",
  ExtraTimeSecondHalf = "EXTRA_TIME_SECOND_HALF",
}
